import { cn } from "@/lib/class-control";

interface StepIndicatorProps {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  completedSteps: Array<number>;
  totalSteps: number;
  className?: string;
}

export function StepIndicator({ currentStep, setCurrentStep, completedSteps, totalSteps, className }: StepIndicatorProps) {
  return (
    <div className="w-full">
      <ol className={cn("flex items-center justify-center mb-8 gap-[60px]", className)}>
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <li
              key={stepNumber}
              className="flex items-center relative"
            >
              {stepNumber < (totalSteps - 1) && (
                <div className="absolute left-[40px] top-1/2 -translate-y-1/2 w-[223px] h-[1px] bg-[#5d5d5d]" />
              )}
              <span
                className={cn(
                  "flex items-center justify-center w-[50px] h-[50px] rounded-full shrink-0 transition-colors relative z-10 font-['Plus_Jakarta_Sans'] text-[20px]",
                  {
                    "bg-[#13d480] text-white": isActive || isCompleted,
                    "bg-[#15203c] text-white": !isActive && !isCompleted,
                    "cursor-pointer": (stepNumber !== currentStep && stepNumber < currentStep) || completedSteps.includes(stepNumber),
                  },
                )}
                onClick={() => {
                  if (stepNumber < currentStep || completedSteps.includes(stepNumber)) {
                    setCurrentStep(stepNumber);
                  }
                }}
              >
                {stepNumber}
              </span>
            </li>
          )
        })}
      </ol>
    </div>
  );
}